import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsService {
  constructor() { }
  public static get TAG_NAME(): string {
    return 'llc_optimization';
  }

  public static get MANAGER_TITLES(): string[] {
    return ['Chairman', 'Chairperson', 'Chairwoman', 'Chief Executive Officer', 'Chief Financial Officer',
      'General Manager', 'Manager', 'Managing Member', 'Member', 'President', 'Secretary', 'Treasurer',
      'Vice President'];
  }

  public static get OWNER_TITLES(): string[] {
    return ['Chairman', 'Chairperson', 'Chairwoman', 'Chief Executive Officer', 'Chief Financial Officer',
      'General Manager', 'Manager', 'Managing Member', 'Member', 'President', 'Secretary', 'Treasurer',
      'Vice President'];
  }

  public static get STATES_ALLOW_DISSOLVE(): string[] {
    return ['Alabama', 'Arizona', 'Hawaii', 'Louisiana', 'Illinois', 'Indiana', 'Iowa', 'Massachusetts',
      'Mississippi', 'Michigan', 'Minnesota', 'Missouri', 'Montana', 'Nevada', 'New Hampshire', 'New Jersey',
      'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'South Carolina',
      'South Dakota', 'Tennessee', 'Utah', 'Vermont', 'Washington', 'West Virginia'];
  }

  public static get STATES_REQUIRING_BIZ_PURPOSE_DESC(): string[] {
    return ['Delaware', 'Massachusetts', 'Maryland', 'Missouri', 'New Mexico', 'New Jersey', 'Oregon', 'Utah'];
  }

  public static get STATES_REQUIRING_NAICS_CODE(): string[] {
    return ['Alaska', 'Louisiana', 'Mississippi'];
  }

  public static get STATES_REQUIRING_BIZ_COUNTY(): string[] {
    return ['New York', 'Pennsylvania'];
  }

  public static get STATES_REQUIRING_BIZ_EMAIL(): string[] {
    return ['Connecticut', 'Mississippi', 'Oklahoma', 'Vermont', 'Georgia', 'Washington', 'South Dakota'];
  }

  public static get STATES_REQUIRING_BIZ_PHONE(): string[] {
    return ['Wyoming', 'Arkansas', 'North Carolina'];
  }

  public static get STATES_REQUIRING_FORMATION_DATE(): string[] {
    return ['Idaho', 'Montana', 'New Mexico', 'Mississippi', 'Vermont'];
  }

  public static get STATES_REQUIRING_SOS_RETRY(): string[] {
    return ['Idaho', 'Montana', 'New Mexico', 'Mississippi', 'Vermont'];
  }

  public static get STATES_REQUIRING_ATTORNEY(): string[] {
    return ['New York'];
  }

  public static get STATES_REQUIRING_LIMITED_SCOPE_AGREEMENT(): string[] {
    return ['Tennessee'];
  }

  public static get STATES_REQUIRING_OWNERS_MARRIED(): string[] {
    return ['Arizona', 'California', 'Idaho', 'Louisiana', 'Nevada', 'New Mexico', 'Texas', 'Washington', 'Wisconsin'];
  }

  public static get STATES_NOT_ALLOW_OUT_OF_STATE(): string[] {
    return ['Alaska', 'Arizona', 'California', 'Idaho', 'Louisiana', 'Maryland', 'Massachusetts', 'Nebraska',
      'New Hampshire', 'New Jersey', 'Oregon', 'Pennsylvania', 'South Carolina', 'Tennessee', 'West Virginia'];
  }

  public static get STATES_NOT_ALLOW_PO_BOX(): string[] {
    return ['Alaska', 'Arizona', 'California', 'Colorado', 'Connecticut', 'Dist. of Columbia', 'District of Columbia',
      'Florida', 'Georgia', 'Idaho', 'Illinois', 'Iowa', 'Louisiana', 'Maryland', 'Massachusetts', 'Montana',
      'Nebraska', 'New Hampshire', 'New Mexico', 'North Carolina', 'North Dakota', 'Oklahoma', 'Pennsylvania',
      'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Utah', 'Virginia', 'West Virginia'];
  }

  public static get STATES_NOT_ALLOW_PROLLC(): string[] {
    return ['Alabama', 'Alaska', 'California', 'Delaware', 'Georgia', 'Hawaii', 'Indiana', 'Louisiana', 'Maryland',
      'Missouri', 'New Jersey', 'New Mexico', 'Ohio', 'Oregon', 'Rhode Island', 'South Carolina', 'South Dakota',
      'Wisconsin', 'Wyoming', 'New York'];
  }

  public static get STATES_REQUIRING_FISCAL_DATE_WITHOUT_EIN(): string[] {
    return ['Kansas', 'New Jersey', 'Tennessee', 'Vermont'];
  }

  public static get STATES_REQUIRING_RA(): string[] {
    return ['New York', 'Minnesota', 'Pennsylvania'];
  }

  public static get STATES_REQUIRING_RA_EMAIL(): string[] {
    return ['Dist. of Columbia', 'District of Columbia', 'Georgia', 'Indiana', 'Ohio', 'South Dakota', 'Mississippi'];
  }

  public static get STATES_REQUIRING_CRA_INDICATOR(): string[] {
    return ['South Dakota'];
  }

  public static get STATES_REQUIRING_NAICS_NEW_URL(): string[] {
    return ['Alaska'];
  }

  public static get STATES_SHOW_NAME_EXPLANATION(): string[] {
    return ['Delaware', 'Dist. of Columbia', 'District of Columbia', 'New York', 'Nevada', 'Wyoming'];
  }

  public static GetAllStates(): { name: string, abbr: string }[] {
    return this.STATES;
  }

  public static GetAllMonths(): { name: string, days: number }[] {
    return [
      { name: 'January', days: 31 },
      { name: 'February', days: 28 },
      { name: 'March', days: 31 },
      { name: 'April', days: 30 },
      { name: 'May', days: 31 },
      { name: 'June', days: 30 },
      { name: 'July', days: 31 },
      { name: 'August', days: 31 },
      { name: 'September', days: 30 },
      { name: 'October', days: 31 },
      { name: 'November', days: 30 },
      { name: 'December', days: 31 }
    ];
  }

  public static getStateAbbr(state) {
    const abbr = this.STATES.find(e => typeof state === 'string' && e.name.toLowerCase() === state.trim().toLowerCase());
    return abbr ? abbr.abbr : '';
  }

  public static getStateByAbbr(abbr) {
    const state = this.STATES.find(e => typeof abbr === 'string' && e.abbr === abbr.trim().toUpperCase());
    return (state && state.name) ? state.name : abbr.trim().toUpperCase();
  }

  public static getStateByName(name) {
    return this.STATES.find(e => typeof name === 'string' && e.name.toLowerCase() === name.trim().toLowerCase());
  }

  public static getStateExpedite(state) {
    const province = this.EXPEDITEPERSTATE.find(e => typeof state === 'string' && e.name.toLowerCase() === state.trim().toLowerCase());
    return province ? province.expediteTAT : '';
  }

  public static getState(input) {
    let s;
    if (!input) {
      input = {};
      input.name = '';
    }

    // tslint:disable-next-line: prefer-for-of
    for (let x = 0; x < this.STATES.length; x++) {
      if (this.STATES[x].name.toLowerCase() === input.name.trim().toLowerCase()) {
        s = this.STATES[x];
      }
    }
    return s;
  }

  private static get STATES(): { name: string, abbr: string }[] {
    return [
      { name: 'Alabama', abbr: 'AL' },
      { name: 'Alaska', abbr: 'AK' },
      { name: 'Arizona', abbr: 'AZ' },
      { name: 'Arkansas', abbr: 'AR' },
      { name: 'California', abbr: 'CA' },
      { name: 'Colorado', abbr: 'CO' },
      { name: 'Connecticut', abbr: 'CT' },
      { name: 'Delaware', abbr: 'DE' },
      { name: 'Dist. of Columbia', abbr: 'DC' },
      { name: 'Florida', abbr: 'FL' },
      { name: 'Georgia', abbr: 'GA' },
      { name: 'Hawaii', abbr: 'HI' },
      { name: 'Idaho', abbr: 'ID' },
      { name: 'Illinois', abbr: 'IL' },
      { name: 'Indiana', abbr: 'IN' },
      { name: 'Iowa', abbr: 'IA' },
      { name: 'Kansas', abbr: 'KS' },
      { name: 'Kentucky', abbr: 'KY' },
      { name: 'Louisiana', abbr: 'LA' },
      { name: 'Maine', abbr: 'ME' },
      { name: 'Maryland', abbr: 'MD' },
      { name: 'Massachusetts', abbr: 'MA' },
      { name: 'Michigan', abbr: 'MI' },
      { name: 'Minnesota', abbr: 'MN' },
      { name: 'Mississippi', abbr: 'MS' },
      { name: 'Missouri', abbr: 'MO' },
      { name: 'Montana', abbr: 'MT' },
      { name: 'Nebraska', abbr: 'NE' },
      { name: 'Nevada', abbr: 'NV' },
      { name: 'New Hampshire', abbr: 'NH' },
      { name: 'New Jersey', abbr: 'NJ' },
      { name: 'New Mexico', abbr: 'NM' },
      { name: 'New York', abbr: 'NY' },
      { name: 'North Carolina', abbr: 'NC' },
      { name: 'North Dakota', abbr: 'ND' },
      { name: 'Ohio', abbr: 'OH' },
      { name: 'Oklahoma', abbr: 'OK' },
      { name: 'Oregon', abbr: 'OR' },
      { name: 'Pennsylvania', abbr: 'PA' },
      { name: 'Rhode Island', abbr: 'RI' },
      { name: 'South Carolina', abbr: 'SC' },
      { name: 'South Dakota', abbr: 'SD' },
      { name: 'Tennessee', abbr: 'TN' },
      { name: 'Texas', abbr: 'TX' },
      { name: 'Utah', abbr: 'UT' },
      { name: 'Vermont', abbr: 'VT' },
      { name: 'Virginia', abbr: 'VA' },
      { name: 'Washington', abbr: 'WA' },
      { name: 'West Virginia', abbr: 'WV' },
      { name: 'Wisconsin', abbr: 'WI' },
      { name: 'Wyoming', abbr: 'WY' }];
  }

  private static get EXPEDITEPERSTATE(): { name: string, expediteTAT: string }[] {
    return [
      { name: 'Alabama', expediteTAT: '11-13' },
      { name: 'Alaska', expediteTAT: '8-10' },
      { name: 'Arizona', expediteTAT: '17-19' },
      { name: 'Arkansas', expediteTAT: '7-9' },
      { name: 'California', expediteTAT: '10-12' },
      { name: 'Colorado', expediteTAT: '7-9' },
      { name: 'Connecticut', expediteTAT: '8-10' },
      { name: 'Delaware', expediteTAT: '10-12' },
      { name: 'Dist. of Columbia', expediteTAT: '13-15' },
      { name: 'Florida', expediteTAT: '12-14' },
      { name: 'Georgia', expediteTAT: '9-11' },
      { name: 'Hawaii', expediteTAT: '9-11' },
      { name: 'Idaho', expediteTAT: '13-15' },
      { name: 'Illinois', expediteTAT: '7-9' },
      { name: 'Indiana', expediteTAT: '12-14' },
      { name: 'Iowa', expediteTAT: '9-11' },
      { name: 'Kansas', expediteTAT: '9-11' },
      { name: 'Kentucky', expediteTAT: '8-10' },
      { name: 'Louisiana', expediteTAT: '11-13' },
      { name: 'Maine', expediteTAT: '14-16' },
      { name: 'Maryland', expediteTAT: '12-14' },
      { name: 'Massachusetts', expediteTAT: '12-14' },
      { name: 'Michigan', expediteTAT: '7-9' },
      { name: 'Minnesota', expediteTAT: '8-10' },
      { name: 'Mississippi', expediteTAT: '6-8' },
      { name: 'Missouri', expediteTAT: '9-11' },
      { name: 'Montana', expediteTAT: '7-9' },
      { name: 'Nebraska', expediteTAT: '9-11' },
      { name: 'Nevada', expediteTAT: '7-9' },
      { name: 'New Hampshire', expediteTAT: '13-15' },
      { name: 'New Jersey', expediteTAT: '8-10' },
      { name: 'New Mexico', expediteTAT: '15-17' },
      { name: 'New York', expediteTAT: '7-9' },
      { name: 'North Carolina', expediteTAT: '7-9' },
      { name: 'North Dakota', expediteTAT: '17-19' },
      { name: 'Ohio', expediteTAT: '11-13' },
      { name: 'Oklahoma', expediteTAT: '8-10' },
      { name: 'Oregon', expediteTAT: '7-9' },
      { name: 'Pennsylvania', expediteTAT: '11-13' },
      { name: 'Rhode Island', expediteTAT: '14-16' },
      { name: 'South Carolina', expediteTAT: '7-9' },
      { name: 'South Dakota', expediteTAT: '7-9' },
      { name: 'Tennessee', expediteTAT: '12-14' },
      { name: 'Texas', expediteTAT: '8-10' },
      { name: 'Utah', expediteTAT: '9-11' },
      { name: 'Vermont', expediteTAT: '13-15' },
      { name: 'Virginia', expediteTAT: '8-10' },
      { name: 'Washington', expediteTAT: '13-15' },
      { name: 'West Virginia', expediteTAT: '8-10' },
      { name: 'Wisconsin', expediteTAT: '7-9' },
      { name: 'Wyoming', expediteTAT: '9-11' }];
  }
  public static get STATES_INCLUDED_IN_STID_SP(): string[] {
    return ['Arizona', 'California', 'Colorado', 'Florida', 'Illinois', 'Minnesota', 'New Jersey', 'Ohio'
    , 'Pennsylvania', 'South Carolina', 'Texas', 'Virginia', 'Washington', 'Wisconsin'];
  }
}

export enum SEAD {
  RA_LZ = 'RA_LZ',
  RA_NOT_LZ = 'RA_NOT_LZ',
  BAP_YES = 'BAP_YES',
  BAP_NO = 'BAP_NO',
  BLP_OA = 'BLP_OA',
  BLP_OA_EIN = 'BLP_OA_EIN',
  BLP_OA_EIN_LIC = 'BLP_OA_EIN_LIC',
  BLP_NO = 'BLP_NO',
  BOFA_YES = 'BOFA_YES',
  BOFA_NO = 'BOFA_NO',
  COMPLIANCE_YES = 'COMPLIANCE_YES',
  COMPLIANCE_NO = 'COMPLIANCE_NO',
  FNAME = 'FNAME',
  LNAME = 'LNAME',
  PHONE_NUMBER = 'PHONE_NUMBER',
  PACKAGE_NAME = 'PACKAGE_NAME',
  ORDER_TOTAL = 'ORDER_TOTAL'
}

export enum ProcessId {
  LLC = 2,
  LastWillAndTestament = 6,
  TrademarkSearch = 13,
  Gsuite = 161
}

export enum QuestionnaireId {
  LastWillAndTestament = 49,
  TrademarkSearch = 77,
  Gsuite = 680
}

export enum StatusType {
  Unsuccess = 0,
  Success = 1
}

export enum TEALIUM_TAGS {
  AttributionJS_DEV = 705,
  AttributionJS_QA = 765,
  AttributionJS_PROD = 720,
  GA_PROD = 533,
  GA_QA = 450,
  AudienceStream = 396,
  Kenshoo_AllNonZeroDollarConversion = 757,
  BingAds_OrderConfirmEvent = 502,
  Facebook_Start_Events = 758,
  Facebook_Order_Complete_Events = 773,
  Facebook_Order_Complete_Events_2 = 678,
  Conversion_trackTransaction = 812,
  Confirm_Image_Pixels = 411,
  PepperJam_TealiumPixel = 798,
  Zeta_Conversion_Tracking = 905,
  Zeta_Page_Tracking = 906,
  LLC_Inc_Checkout_Tracking = 912,
  Adwords_Conversion_Retargeting = 827,
  Proactive_Chat = 786,
  Criteo_View_Cart = 814,
}

export enum CookieName {
  LLC_Formation_State = 'llc_formation_state'
}
